<template>
  <svg
    width="256"
    height="160"
    viewBox="0 0 256 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M237 138.982H19V139.087H237V138.982Z"
      fill="var(--gray400)"
    />
    <path
      d="M203.912 144.847H199.286V144.951H203.912V144.847Z"
      fill="var(--gray400)"
    />
    <path
      d="M196.086 144.894H177.272V144.999H196.086V144.894Z"
      fill="var(--gray400)"
    />
    <path
      d="M154.016 143.901H122.266V144.005H154.016V143.901Z"
      fill="var(--gray400)"
    />
    <path
      d="M104.003 145.715H93.9268V145.82H104.003V145.715Z"
      fill="var(--gray400)"
    />
    <path
      d="M70.4258 143.951H56.5522V144.056H70.4258V143.951Z"
      fill="var(--gray400)"
    />
    <path
      d="M85.8128 143.951H72.8462V144.056H85.8128V143.951Z"
      fill="var(--gray400)"
    />
    <path
      d="M60.7076 142.125H47.4663V142.229H60.7076V142.125Z"
      fill="var(--gray400)"
    />
    <path
      d="M122.332 120.341H38.1449C37.4854 120.34 36.8532 120.088 36.3873 119.641C35.9214 119.193 35.6597 118.587 35.6597 117.955V4.5081C35.6654 3.8795 35.9296 3.27846 36.395 2.83552C36.8603 2.39259 37.4891 2.14353 38.1449 2.14246H122.332C122.992 2.14246 123.626 2.39389 124.092 2.84146C124.559 3.28902 124.822 3.89605 124.822 4.529V117.955C124.822 118.588 124.559 119.195 124.092 119.642C123.626 120.09 122.992 120.341 122.332 120.341ZM38.1449 2.22605C37.5143 2.22716 36.9099 2.46807 36.4644 2.89592C36.0189 3.32377 35.7687 3.90359 35.7687 4.5081V117.955C35.7687 118.559 36.0189 119.139 36.4644 119.567C36.9099 119.995 37.5143 120.236 38.1449 120.237H122.332C122.963 120.236 123.568 119.995 124.014 119.567C124.46 119.139 124.712 118.559 124.713 117.955V4.5081C124.712 3.9032 124.46 3.32339 124.014 2.89567C123.568 2.46794 122.963 2.22715 122.332 2.22605H38.1449Z"
      fill="var(--gray400)"
    />
    <path
      d="M216.644 120.341H132.452C131.792 120.34 131.159 120.088 130.693 119.641C130.226 119.194 129.964 118.587 129.962 117.955V4.5081C129.969 3.87912 130.234 3.27808 130.7 2.83526C131.167 2.39244 131.796 2.14352 132.452 2.14246H216.644C217.299 2.14463 217.926 2.39417 218.391 2.83699C218.855 3.27981 219.119 3.88022 219.124 4.5081V117.955C219.124 118.586 218.863 119.192 218.398 119.639C217.933 120.086 217.302 120.339 216.644 120.341ZM132.452 2.22605C131.821 2.22715 131.216 2.46794 130.77 2.89567C130.324 3.32339 130.073 3.9032 130.071 4.5081V117.955C130.073 118.559 130.324 119.139 130.77 119.567C131.216 119.995 131.821 120.236 132.452 120.237H216.644C217.275 120.236 217.879 119.995 218.326 119.567C218.772 119.139 219.023 118.559 219.024 117.955V4.5081C219.023 3.9032 218.772 3.32339 218.326 2.89567C217.879 2.46794 217.275 2.22715 216.644 2.22605H132.452Z"
      fill="var(--gray400)"
    />
    <path
      d="M110.49 11.116H42.5835V67.7619H110.49V11.116Z"
      fill="var(--gray400)"
    />
    <path
      d="M113.272 11.116H43.8828V67.7619H113.272V11.116Z"
      fill="white"
    />
    <path
      d="M110.49 67.7635H42.5835V70.0372H110.49V67.7635Z"
      fill="var(--gray400)"
    />
    <path
      d="M117.903 67.7635H48.5132V70.0372H117.903V67.7635Z"
      fill="white"
    />
    <path
      d="M109.383 64.0345V14.8449L47.776 14.8449V64.0345H109.383Z"
      fill="white"
    />
    <path
      d="M57.752 64.0345L69.6373 14.8449H85.9481L74.0627 64.0345H57.752Z"
      fill="white"
    />
    <path
      d="M50.0173 55.8142C49.9433 55.8142 49.8723 55.786 49.82 55.7358C49.7677 55.6857 49.7383 55.6176 49.7383 55.5467V17.2701C49.7383 17.1991 49.7677 17.1311 49.82 17.0809C49.8723 17.0307 49.9433 17.0026 50.0173 17.0026C50.0913 17.0026 50.1623 17.0307 50.2146 17.0809C50.267 17.1311 50.2964 17.1991 50.2964 17.2701V55.5467C50.2964 55.6176 50.267 55.6857 50.2146 55.7358C50.1623 55.786 50.0913 55.8142 50.0173 55.8142Z"
      fill="var(--gray400)"
    />
    <path
      d="M77.4062 64.0345L89.2916 14.8449H94.9334L83.0481 64.0345H77.4062Z"
      fill="white"
    />
    <path
      d="M109.379 64.0277V14.8382H108.886V64.0277H109.379Z"
      fill="var(--gray400)"
    />
    <path
      d="M114.192 15.2511H46.2848L45.9272 14.1184H113.834L114.192 15.2511Z"
      fill="var(--gray400)"
    />
    <path
      d="M114.192 17.1198H46.2848L45.9272 15.9871H113.834L114.192 17.1198Z"
      fill="var(--gray400)"
    />
    <path
      d="M114.192 18.9851H46.2848L45.9272 17.8524H113.834L114.192 18.9851Z"
      fill="var(--gray400)"
    />
    <path
      d="M114.192 20.8521H46.2848L45.9272 19.7195H113.834L114.192 20.8521Z"
      fill="var(--gray400)"
    />
    <path
      d="M114.192 22.7225H46.2848L45.9272 21.5898H113.834L114.192 22.7225Z"
      fill="var(--gray400)"
    />
    <path
      d="M114.192 24.5895H46.2848L45.9272 23.4568H113.834L114.192 24.5895Z"
      fill="var(--gray400)"
    />
    <path
      d="M194.791 14.8027H166.237V63.5993H194.791V14.8027Z"
      fill="var(--gray400)"
    />
    <path
      d="M182.321 17.3804C181.891 17.3763 181.472 17.2502 181.116 17.0181C180.761 16.786 180.485 16.4582 180.323 16.076C180.161 15.6938 180.121 15.2743 180.208 14.8703C180.294 14.4663 180.504 14.0959 180.809 13.8057C181.115 13.5155 181.503 13.3185 181.926 13.2396C182.348 13.1606 182.785 13.2032 183.182 13.362C183.579 13.5207 183.919 13.7886 184.157 14.1318C184.396 14.475 184.523 14.8782 184.523 15.2906C184.517 15.8468 184.283 16.3783 183.871 16.7696C183.458 17.1609 182.901 17.3804 182.321 17.3804ZM182.321 13.577C181.977 13.5811 181.642 13.6827 181.358 13.8688C181.074 14.055 180.854 14.3176 180.726 14.6234C180.597 14.9292 180.566 15.2647 180.635 15.5876C180.705 15.9105 180.873 16.2065 181.118 16.4382C181.362 16.6699 181.673 16.8271 182.011 16.8899C182.348 16.9527 182.698 16.9184 183.015 16.7913C183.333 16.6642 183.604 16.4499 183.795 16.1754C183.985 15.901 184.087 15.5786 184.087 15.2488C184.087 15.0275 184.041 14.8084 183.952 14.6042C183.863 14.4 183.733 14.2147 183.569 14.0592C183.404 13.9037 183.209 13.781 182.995 13.6982C182.781 13.6154 182.552 13.5742 182.321 13.577Z"
      fill="var(--gray400)"
    />
    <path
      d="M197.878 14.8027H168.387V63.5993H197.878V14.8027Z"
      fill="white"
    />
    <path
      d="M195.41 61.2293V17.1682H170.859V61.2293H195.41Z"
      fill="white"
    />
    <path
      d="M195.41 61.2293V17.1682H195.105V61.2293H195.41Z"
      fill="var(--gray400)"
    />
    <path
      d="M173.675 80.9542C173.675 80.9542 173.98 85.8736 185.643 85.8736C197.306 85.8736 197.607 80.9542 197.607 80.9542H173.675Z"
      fill="var(--gray200)"
    />
    <path
      d="M150.088 89.7351H138.176V136.764H150.088V89.7351Z"
      fill="var(--gray400)"
    />
    <path
      d="M202.699 136.764H140.465V138.983H202.699V136.764Z"
      fill="var(--gray400)"
    />
    <path
      d="M150.088 136.764H204.984V89.735H150.088V136.764Z"
      fill="white"
    />
    <path
      d="M154.77 118.991H200.302V107.505H154.77V118.991Z"
      fill="var(--gray200)"
    />
    <path
      d="M154.77 132.575H200.302V121.09H154.77V132.575Z"
      fill="var(--gray200)"
    />
    <path
      d="M184.344 108.764H170.728C170.51 108.764 170.302 108.682 170.148 108.534C169.995 108.387 169.908 108.187 169.908 107.979C169.908 107.77 169.994 107.57 170.148 107.422C170.302 107.274 170.51 107.19 170.728 107.189H184.344C184.562 107.19 184.77 107.274 184.924 107.422C185.078 107.57 185.164 107.77 185.164 107.979C185.164 108.187 185.077 108.387 184.924 108.534C184.77 108.682 184.562 108.764 184.344 108.764Z"
      fill="white"
    />
    <path
      d="M154.77 105.408H200.302V93.9225H154.77V105.408Z"
      fill="var(--gray200)"
    />
    <path
      d="M184.344 95.1817H170.728C170.51 95.1806 170.302 95.0969 170.148 94.9489C169.994 94.8009 169.908 94.6006 169.908 94.3918C169.908 94.1834 169.995 93.9835 170.148 93.8362C170.302 93.6888 170.51 93.606 170.728 93.606H184.344C184.562 93.606 184.77 93.6888 184.924 93.8362C185.077 93.9835 185.164 94.1834 185.164 94.3918C185.164 94.6006 185.078 94.8009 184.924 94.9489C184.77 95.0969 184.562 95.1806 184.344 95.1817Z"
      fill="white"
    />
    <path
      d="M184.344 122.347H170.728C170.51 122.346 170.302 122.262 170.148 122.114C169.994 121.966 169.908 121.766 169.908 121.557C169.908 121.349 169.995 121.149 170.148 121.002C170.302 120.854 170.51 120.772 170.728 120.772H184.344C184.562 120.772 184.77 120.854 184.924 121.002C185.077 121.149 185.164 121.349 185.164 121.557C185.164 121.766 185.078 121.966 184.924 122.114C184.77 122.262 184.562 122.346 184.344 122.347Z"
      fill="white"
    />
    <path
      d="M206.571 85.871H150.087V89.7329H206.571V85.871Z"
      fill="var(--gray400)"
    />
    <path
      d="M136.51 89.7385H150.087V85.8766H136.51V89.7385Z"
      fill="var(--gray400)"
    />
    <path
      d="M142.763 85.871H154.601V72.2706H142.763V85.871Z"
      fill="var(--gray400)"
    />
    <path
      d="M175.607 72.2764H154.601V85.8768H175.607V72.2764Z"
      fill="white"
    />
    <path
      d="M169.947 79.4648C169.947 80.4386 167.767 81.2244 165.103 81.2244C162.439 81.2244 160.264 80.4261 160.264 79.4648C160.264 78.5035 162.444 77.7052 165.112 77.7052C167.78 77.7052 169.947 78.4826 169.947 79.4648Z"
      fill="white"
    />
    <g
      style="mix-blend-mode:multiply"
      opacity="0.7"
    >
      <path
        d="M142.763 74.9476H175.729V74.0156H142.763V74.9476Z"
        fill="var(--gray400)"
      />
    </g>
    <path
      d="M142.105 74.4104H154.596V71.7104H142.105V74.4104Z"
      fill="var(--gray400)"
    />
    <path
      d="M176.257 71.707H154.601V74.407H176.257V71.707Z"
      fill="white"
    />
    <path
      d="M94.794 79.0721H49.668L52.4845 138.982H97.6105L94.794 79.0721Z"
      fill="var(--gray400)"
    />
    <path
      d="M95.4478 79.072H50.3218L53.1383 138.982H98.2643L95.4478 79.072Z"
      fill="white"
    />
    <path
      d="M60.272 138.982H72.1094V125.382H60.272V138.982Z"
      fill="var(--gray400)"
    />
    <path
      d="M128.781 125.382H72.1138V138.983H128.781V125.382Z"
      fill="white"
    />
    <g
      style="mix-blend-mode:multiply"
      opacity="0.7"
    >
      <path
        d="M60.2716 128.057H128.902V127.125L60.2716 127.125V128.057Z"
        fill="var(--gray400)"
      />
    </g>
    <path
      d="M59.6224 127.518H72.1138V124.818H59.6224V127.518Z"
      fill="var(--gray400)"
    />
    <path
      d="M129.435 124.818H72.1138V127.518H129.435V124.818Z"
      fill="white"
    />
    <path
      d="M70.0864 124.818H85.4902V100.246H70.0864V124.818Z"
      fill="var(--gray200)"
    />
    <path
      d="M123.976 100.246H85.4858V124.818H123.976V100.246Z"
      fill="var(--gray200)"
    />
    <g
      style="mix-blend-mode:multiply"
      opacity="0.7"
    >
      <path
        d="M70.0824 103.723H124.138V102.511H70.0824V103.723Z"
        fill="var(--gray400)"
      />
    </g>
    <path
      d="M69.2362 103.022H85.4902V97.4383H69.2362V103.022Z"
      fill="var(--gray400)"
    />
    <path
      d="M124.826 97.4363H85.4858V103.02H124.826V97.4363Z"
      fill="var(--gray400)"
    />
    <path
      d="M52.9245 138.983C58.9372 138.983 63.8114 134.311 63.8114 128.547C63.8114 122.783 58.9372 118.11 52.9245 118.11C46.9118 118.11 42.0376 122.783 42.0376 128.547C42.0376 134.311 46.9118 138.983 52.9245 138.983Z"
      fill="white"
    />
    <g
      style="mix-blend-mode:multiply"
      opacity="0.7"
    >
      <path
        d="M47.5928 122.322C48.2381 121.678 48.4997 120.909 48.1683 120.608C47.837 120.308 47.0478 120.579 46.4025 121.223C45.7572 121.867 45.4956 122.636 45.8226 122.941C46.1496 123.246 46.9432 122.97 47.5928 122.322Z"
        fill="var(--gray400)"
      />
    </g>
    <g
      style="mix-blend-mode:multiply"
      opacity="0.7"
    >
      <path
        d="M52.1361 120.367C53.0517 120.199 53.7275 119.714 53.6403 119.284C53.5531 118.854 52.7421 118.64 51.8222 118.812C50.9022 118.983 50.2351 119.464 50.318 119.894C50.4008 120.325 51.1987 120.538 52.1361 120.367Z"
        fill="var(--gray400)"
      />
    </g>
    <g
      style="mix-blend-mode:multiply"
      opacity="0.7"
    >
      <path
        d="M51.1859 124.011C52.0579 123.715 52.6291 123.054 52.4372 122.536C52.2454 122.018 51.3778 121.838 50.497 122.118C49.6163 122.398 49.0582 123.075 49.2457 123.593C49.4332 124.112 50.3052 124.308 51.1859 124.011Z"
        fill="var(--gray400)"
      />
    </g>
    <path
      d="M128 157.858C174.688 157.858 212.536 155.739 212.536 153.126C212.536 150.513 174.688 148.395 128 148.395C81.3119 148.395 43.4639 150.513 43.4639 153.126C43.4639 155.739 81.3119 157.858 128 157.858Z"
      fill="var(--gray50)"
    />
    <path
      d="M152.957 25.731H102.782C99.2616 25.731 96.4077 28.4668 96.4077 31.8416V147.01C96.4077 150.385 99.2616 153.121 102.782 153.121H152.957C156.477 153.121 159.331 150.385 159.331 147.01V31.8416C159.331 28.4668 156.477 25.731 152.957 25.731Z"
      fill="var(--brandPrimary)"
    />
    <path
      opacity="0.7"
      d="M152.957 25.731H102.782C99.2616 25.731 96.4077 28.4668 96.4077 31.8416V147.01C96.4077 150.385 99.2616 153.121 102.782 153.121H152.957C156.477 153.121 159.331 150.385 159.331 147.01V31.8416C159.331 28.4668 156.477 25.731 152.957 25.731Z"
      fill="white"
    />
    <path
      d="M154.64 25.5147H104.465C100.944 25.5147 98.0903 28.2505 98.0903 31.6253V146.794C98.0903 150.168 100.944 152.904 104.465 152.904H154.64C158.16 152.904 161.014 150.168 161.014 146.794V31.6253C161.014 28.2505 158.16 25.5147 154.64 25.5147Z"
      fill="var(--brandPrimary)"
    />
    <path
      opacity="0.2"
      d="M154.64 25.5147H104.465C100.944 25.5147 98.0903 28.2505 98.0903 31.6253V146.794C98.0903 150.168 100.944 152.904 104.465 152.904H154.64C158.16 152.904 161.014 150.168 161.014 146.794V31.6253C161.014 28.2505 158.16 25.5147 154.64 25.5147Z"
      fill="var(--black)"
    />
    <path
      d="M132.007 147.291C132.008 147.83 131.842 148.357 131.531 148.805C131.219 149.253 130.776 149.602 130.257 149.809C129.738 150.015 129.167 150.069 128.616 149.964C128.065 149.86 127.559 149.6 127.162 149.22C126.765 148.839 126.494 148.354 126.385 147.825C126.276 147.297 126.332 146.75 126.547 146.252C126.763 145.755 127.127 145.33 127.595 145.032C128.062 144.733 128.612 144.574 129.173 144.575C129.925 144.575 130.646 144.861 131.177 145.37C131.709 145.88 132.007 146.571 132.007 147.291Z"
      fill="var(--brandPrimary)"
    />
    <path
      opacity="0.4"
      d="M132.007 147.291C132.008 147.83 131.842 148.357 131.531 148.805C131.219 149.253 130.776 149.602 130.257 149.809C129.738 150.015 129.167 150.069 128.616 149.964C128.065 149.86 127.559 149.6 127.162 149.22C126.765 148.839 126.494 148.354 126.385 147.825C126.276 147.297 126.332 146.75 126.547 146.252C126.763 145.755 127.127 145.33 127.595 145.032C128.062 144.733 128.612 144.574 129.173 144.575C129.925 144.575 130.646 144.861 131.177 145.37C131.709 145.88 132.007 146.571 132.007 147.291Z"
      fill="var(--black)"
    />
    <path
      d="M160.509 143.308H97.8989V33.8361H160.945L160.509 143.308Z"
      fill="var(--brandPrimary)"
    />
    <path
      opacity="0.8"
      d="M161.062 143.248L97.8643 143.319V33.843L161.006 33.7803L161.062 143.248Z"
      fill="white"
    />
    <path
      opacity="0.33"
      d="M93.1333 35.6708H92.6973V41.1962H93.1333V35.6708Z"
      fill="var(--brandPrimary)"
    />
    <path
      opacity="0.33"
      d="M93.1333 42.7319H92.6973V44.4622H93.1333V42.7319Z"
      fill="var(--brandPrimary)"
    />
    <path
      d="M147.402 38.3676H103.972C101.579 38.3676 99.6382 40.2277 99.6382 42.5221V67.3739C99.6382 69.6684 101.579 71.5284 103.972 71.5284H147.402C149.796 71.5284 151.736 69.6684 151.736 67.3739V42.5221C151.736 40.2277 149.796 38.3676 147.402 38.3676Z"
      fill="white"
    />
    <path
      d="M148.54 74.5912H102.834C101.069 74.5912 99.6382 75.9629 99.6382 77.6549V83.1343C99.6382 84.8263 101.069 86.1979 102.834 86.1979H148.54C150.305 86.1979 151.736 84.8263 151.736 83.1343V77.6549C151.736 75.9629 150.305 74.5912 148.54 74.5912Z"
      fill="white"
    />
    <path
      d="M160.591 87.3228L166.752 103.598C166.911 104.024 166.888 104.493 166.688 104.902C166.488 105.311 166.127 105.628 165.684 105.784L133.363 117.023C132.92 117.175 132.431 117.154 132.004 116.963C131.577 116.772 131.246 116.427 131.083 116.003L124.922 99.7236C124.762 99.2985 124.785 98.83 124.985 98.4209C125.186 98.0118 125.547 97.6957 125.99 97.5419L158.311 86.2988C158.755 86.1466 159.244 86.1688 159.671 86.3606C160.098 86.5524 160.429 86.8983 160.591 87.3228Z"
      fill="var(--brandSecondary)"
    />
    <path
      d="M159.615 86.3382L150.376 100.912C149.52 102.264 148.209 103.294 146.658 103.833C145.108 104.372 143.412 104.387 141.852 103.876L125.014 98.367C125.217 97.9795 125.566 97.6806 125.99 97.5311L158.311 86.2881C158.737 86.1467 159.202 86.1646 159.615 86.3382Z"
      fill="var(--brandSecondary)"
    />
    <path
      opacity="0.5"
      d="M159.615 86.3382L150.376 100.912C149.52 102.264 148.209 103.294 146.658 103.833C145.108 104.372 143.412 104.387 141.852 103.876L125.014 98.367C125.217 97.9795 125.566 97.6806 125.99 97.5311L158.311 86.2881C158.737 86.1467 159.202 86.1646 159.615 86.3382Z"
      fill="white"
    />
    <path
      d="M150.454 115.296L150.158 129.958C150.149 130.341 149.982 130.704 149.695 130.97C149.407 131.235 149.022 131.381 148.623 131.375L119.503 130.832C119.305 130.828 119.11 130.787 118.929 130.711C118.748 130.635 118.585 130.526 118.448 130.389C118.311 130.252 118.204 130.091 118.132 129.915C118.06 129.738 118.025 129.55 118.029 129.361L118.321 114.699C118.327 114.5 118.374 114.305 118.46 114.125C118.546 113.945 118.669 113.783 118.823 113.65C119.106 113.407 119.475 113.275 119.856 113.282L148.976 113.821C149.376 113.83 149.756 113.99 150.033 114.266C150.31 114.543 150.461 114.913 150.454 115.296Z"
      fill="var(--brandSecondary)"
    />
    <path
      d="M149.996 114.231L138.067 123.058C136.961 123.876 135.597 124.307 134.2 124.282C132.803 124.256 131.458 123.774 130.385 122.916L118.844 113.65C119.128 113.407 119.497 113.275 119.878 113.282L148.998 113.821C149.372 113.834 149.728 113.98 149.996 114.231Z"
      fill="var(--brandSecondary)"
    />
    <path
      opacity="0.5"
      d="M149.996 114.231L138.067 123.058C136.961 123.876 135.597 124.307 134.2 124.282C132.803 124.256 131.458 123.774 130.385 122.916L118.844 113.65C119.128 113.407 119.497 113.275 119.878 113.282L148.998 113.821C149.372 113.834 149.728 113.98 149.996 114.231Z"
      fill="white"
    />
    <path
      d="M121.081 28.9641C121.082 28.7741 121.141 28.5887 121.252 28.4312C121.363 28.2736 121.52 28.1511 121.703 28.0789C121.886 28.0068 122.088 27.9884 122.282 28.0259C122.476 28.0635 122.655 28.1554 122.794 28.29C122.934 28.4246 123.029 28.5959 123.068 28.7823C123.106 28.9686 123.086 29.1617 123.01 29.3371C122.934 29.5125 122.805 29.6624 122.641 29.7678C122.476 29.8733 122.282 29.9296 122.084 29.9296C121.952 29.9296 121.821 29.9046 121.699 29.856C121.577 29.8074 121.466 29.7362 121.373 29.6465C121.28 29.5568 121.206 29.4504 121.156 29.3332C121.106 29.2161 121.08 29.0907 121.081 28.9641Z"
      fill="var(--brandPrimary)"
    />
    <path
      d="M125.55 28.0002H133.882C134.148 28.0013 134.402 28.1029 134.59 28.283C134.778 28.463 134.884 28.7069 134.885 28.9615C134.885 29.2168 134.779 29.4618 134.591 29.6427C134.404 29.8237 134.148 29.9259 133.882 29.927H125.55C125.284 29.9259 125.029 29.8237 124.841 29.6427C124.653 29.4618 124.547 29.2168 124.547 28.9615C124.549 28.7069 124.655 28.463 124.842 28.283C125.03 28.1029 125.285 28.0013 125.55 28.0002Z"
      fill="var(--brandPrimary)"
    />
    <path
      opacity="0.4"
      d="M121.081 28.9641C121.082 28.7741 121.141 28.5887 121.252 28.4312C121.363 28.2736 121.52 28.1511 121.703 28.0789C121.886 28.0068 122.088 27.9884 122.282 28.0259C122.476 28.0635 122.655 28.1554 122.794 28.29C122.934 28.4246 123.029 28.5959 123.068 28.7823C123.106 28.9686 123.086 29.1617 123.01 29.3371C122.934 29.5125 122.805 29.6624 122.641 29.7678C122.476 29.8733 122.282 29.9296 122.084 29.9296C121.952 29.9296 121.821 29.9046 121.699 29.856C121.577 29.8074 121.466 29.7362 121.373 29.6465C121.28 29.5568 121.206 29.4504 121.156 29.3332C121.106 29.2161 121.08 29.0907 121.081 28.9641Z"
      fill="var(--black)"
    />
    <path
      opacity="0.4"
      d="M125.55 28.0002H133.882C134.148 28.0013 134.402 28.1029 134.59 28.283C134.778 28.463 134.884 28.7069 134.885 28.9615C134.885 29.2168 134.779 29.4618 134.591 29.6427C134.404 29.8237 134.148 29.9259 133.882 29.927H125.55C125.284 29.9259 125.029 29.8237 124.841 29.6427C124.653 29.4618 124.547 29.2168 124.547 28.9615C124.549 28.7069 124.655 28.463 124.842 28.283C125.03 28.1029 125.285 28.0013 125.55 28.0002Z"
      fill="var(--black)"
    />
    <path
      d="M161.101 47.3698H156.946C155.981 47.3698 155.198 48.1202 155.198 49.0459V61.1792C155.198 62.1048 155.981 62.8552 156.946 62.8552H161.101C162.067 62.8552 162.85 62.1048 162.85 61.1792V49.0459C162.85 48.1202 162.067 47.3698 161.101 47.3698Z"
      fill="var(--brandPrimary)"
    />
    <path
      opacity="0.8"
      d="M161.101 47.3698H156.946C155.981 47.3698 155.198 48.1202 155.198 49.0459V61.1792C155.198 62.1048 155.981 62.8552 156.946 62.8552H161.101C162.067 62.8552 162.85 62.1048 162.85 61.1792V49.0459C162.85 48.1202 162.067 47.3698 161.101 47.3698Z"
      fill="white"
    />
    <path
      d="M161.537 67.3224H156.51C155.785 67.3224 155.198 67.8857 155.198 68.5805V74.7997C155.198 75.4945 155.785 76.0578 156.51 76.0578H161.537C162.262 76.0578 162.85 75.4945 162.85 74.7997V68.5805C162.85 67.8857 162.262 67.3224 161.537 67.3224Z"
      fill="var(--brandPrimary)"
    />
    <path
      opacity="0.8"
      d="M161.537 67.3224H156.51C155.785 67.3224 155.198 67.8857 155.198 68.5805V74.7997C155.198 75.4945 155.785 76.0578 156.51 76.0578H161.537C162.262 76.0578 162.85 75.4945 162.85 74.7997V68.5805C162.85 67.8857 162.262 67.3224 161.537 67.3224Z"
      fill="white"
    />
    <mask
      id="mask0_109_15314"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="96"
      y="33"
      width="64"
      height="110"
    >
      <path
        d="M159.196 33.4103H96.2725V142.886H159.196V33.4103Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_109_15314)">
      <path
        d="M105.755 140.246L108.96 140.543L112.295 133.233L109.091 132.932L105.755 140.246Z"
        fill="#FFC3BD"
      />
      <path
        d="M112.296 133.233L110.578 137.003H107.234L109.087 132.932L112.296 133.233Z"
        fill="#ED847E"
      />
      <path
        d="M117.87 56.1166H106.707C106.285 56.1166 105.879 55.9556 105.58 55.6689C105.281 55.3822 105.113 54.9934 105.113 54.588V43.8872C105.113 43.4817 105.281 43.0929 105.58 42.8062C105.879 42.5195 106.285 42.3585 106.707 42.3585H115.478L119.465 46.1802V54.588C119.465 54.9934 119.297 55.3822 118.998 55.6689C118.699 55.9556 118.293 56.1166 117.87 56.1166Z"
        fill="var(--brandPrimary)"
        stroke="var(--brandPrimary)"
        stroke-width="0.865079"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M116.275 56.1153V50.0006H108.302V56.1153"
        stroke="white"
        stroke-width="0.865079"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M108.302 42.3585V46.9445H114.68"
        stroke="white"
        stroke-width="0.865079"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M141.791 65.4298L141.896 65.6555L142.031 65.9188C142.118 66.0944 142.218 66.2741 142.318 66.4538C142.523 66.8091 142.754 67.1685 142.972 67.5112C143.432 68.2129 143.937 68.8858 144.485 69.5258C145.044 70.1597 145.639 70.7625 146.269 71.3314C146.596 71.6072 146.914 71.8914 147.254 72.1673L147.764 72.5518L147.882 72.6438C147.826 72.6272 147.769 72.616 147.712 72.6103C147.585 72.5979 147.458 72.6166 147.341 72.6647C147.27 72.6846 147.206 72.7237 147.158 72.7775C147.128 72.8193 147.206 72.7524 147.271 72.6438C147.444 72.339 147.58 72.0165 147.677 71.6825C147.916 70.8708 148.104 70.0459 148.239 69.2123C148.388 68.3513 148.51 67.4695 148.606 66.5876C148.702 65.7057 148.802 64.8071 148.889 63.9293L150.572 63.9043C150.677 64.8363 150.72 65.7433 150.759 66.6711C150.799 67.599 150.781 68.5185 150.759 69.4589C150.721 70.4258 150.606 71.3885 150.415 72.3387C150.305 72.886 150.127 73.4191 149.887 73.9269C149.714 74.2863 149.474 74.6132 149.181 74.8924C148.954 75.0972 148.687 75.2577 148.396 75.3647C148.057 75.4864 147.692 75.5294 147.332 75.4901C147.04 75.4533 146.757 75.3684 146.495 75.2393C146.391 75.1888 146.289 75.133 146.19 75.0721L146.024 74.9676L145.388 74.5497C144.952 74.2738 144.568 73.9687 144.171 73.6636C143.387 73.0356 142.651 72.354 141.97 71.624C141.293 70.8875 140.671 70.1068 140.108 69.2876C139.829 68.8696 139.572 68.4516 139.323 68.0337C139.201 67.8122 139.083 67.5948 138.97 67.365L138.804 67.0097C138.748 66.8843 138.704 66.784 138.634 66.6126L141.791 65.4298Z"
        fill="#FFC3BD"
      />
      <path
        d="M143.265 67.5894L140.335 71.4639L141.547 72.6049L144.664 69.0104L143.265 67.5894Z"
        fill="white"
      />
      <path
        d="M138.669 62.4813C141.97 63.3172 144.246 67.7559 144.246 67.7559L140.435 72.8759C140.435 72.8759 135.848 67.3463 135.966 65.5993C136.079 63.7686 136.681 61.9672 138.669 62.4813Z"
        fill="var(--brandPrimary)"
      />
      <path
        opacity="0.7"
        d="M138.669 62.4813C141.97 63.3172 144.246 67.7559 144.246 67.7559L140.435 72.8759C140.435 72.8759 135.848 67.3463 135.966 65.5993C136.079 63.7686 136.681 61.9672 138.669 62.4813Z"
        fill="white"
      />
      <path
        d="M141.516 64.1128C141.516 64.1128 142.602 65.3416 130.036 79.92L118.408 73.3915C121.373 68.9653 123.086 66.1691 126.509 55.5864C128.337 56.1759 130.118 56.8925 131.837 57.7306C133.661 58.6116 135.426 59.6013 137.121 60.6939C139.266 62.1651 141.516 64.1128 141.516 64.1128Z"
        fill="var(--brandPrimary)"
      />
      <path
        opacity="0.7"
        d="M141.516 64.1128C141.516 64.1128 142.602 65.3416 130.036 79.92L118.408 73.3915C121.373 68.9653 123.086 66.1691 126.509 55.5864C128.337 56.1759 130.118 56.8925 131.837 57.7306C133.661 58.6116 135.426 59.6013 137.121 60.6939C139.266 62.1651 141.516 64.1128 141.516 64.1128Z"
        fill="white"
      />
      <path
        d="M140.008 62.8537C139.188 62.2017 138.137 61.395 137.122 60.6928C135.436 59.5864 133.67 58.5961 131.837 57.7295C130.808 57.2154 129.753 56.764 128.855 56.4213C128.711 56.6512 128.829 57.3533 129.269 58.3815C130.943 60.4504 134.833 63.4973 138.076 64.1034C139.585 63.8944 140.056 63.4346 140.008 62.8537Z"
        fill="white"
      />
      <path
        d="M129.269 58.3844C130.246 60.4715 131.547 62.4049 133.128 64.1188C134.773 64.2763 136.431 64.2763 138.076 64.1188C134.832 63.5002 130.943 60.4533 129.269 58.3844Z"
        fill="white"
      />
      <path
        d="M130.049 79.92C130.049 79.92 130.237 108.559 124.94 116.826C119.428 125.423 112.243 135.91 112.243 135.91L106.021 135.621C106.021 135.621 113.277 120.107 116.015 112.905C119.786 102.979 121.53 75.1385 121.53 75.1385L130.049 79.92Z"
        fill="var(--brandPrimary)"
      />
      <path
        opacity="0.4"
        d="M130.049 79.92C130.049 79.92 130.237 108.559 124.94 116.826C119.428 125.423 112.243 135.91 112.243 135.91L106.021 135.621C106.021 135.621 113.277 120.107 116.015 112.905C119.786 102.979 121.53 75.1385 121.53 75.1385L130.049 79.92Z"
        fill="var(--black)"
      />
      <path
        opacity="0.2"
        d="M123.432 80.7193C122.424 81.5386 121.557 82.5047 120.864 83.5823C120.667 85.7139 120.428 88.1088 120.153 90.6166C122.049 88.1464 123.549 83.8122 123.432 80.7193Z"
        fill="var(--black)"
      />
      <path
        d="M126.976 78.2119C126.976 78.2119 113.813 96.1256 105.612 105.797C98.9843 113.592 79.8003 119.172 79.8003 119.172L77.459 115.41C77.459 115.41 92.719 107.243 97.2708 101.969C111.842 85.0831 111.659 76.3269 118.426 73.4388L126.976 78.2119Z"
        fill="var(--brandPrimary)"
      />
      <path
        opacity="0.4"
        d="M126.976 78.2119C126.976 78.2119 113.813 96.1256 105.612 105.797C98.9843 113.592 79.8003 119.172 79.8003 119.172L77.459 115.41C77.459 115.41 92.719 107.243 97.2708 101.969C111.842 85.0831 111.659 76.3269 118.426 73.4388L126.976 78.2119Z"
        fill="var(--black)"
      />
      <path
        d="M148.929 64.3216L148.057 60.978L151.383 61.9058C151.383 61.9058 151.292 64.1544 150.141 64.8859L148.929 64.3216Z"
        fill="#FFC3BD"
      />
      <path
        d="M149.116 58.2965L151.453 59.4292L151.396 61.9244L148.069 60.9965L149.116 58.2965Z"
        fill="#FFC3BD"
      />
      <path
        d="M107.325 59.5229L104.273 57.7257L107.325 56.1626C107.325 56.1626 108.89 57.8344 108.602 59.1301L107.325 59.5229Z"
        fill="#FFC3BD"
      />
      <path
        d="M103.065 55.0884L105.564 54.3361L107.343 56.1626L104.278 57.7258L103.065 55.0884Z"
        fill="#FFC3BD"
      />
      <path
        d="M109.388 139.595H105.464C105.393 139.596 105.324 139.619 105.268 139.66C105.212 139.702 105.172 139.76 105.154 139.825L104.282 142.814C104.261 142.884 104.257 142.958 104.271 143.03C104.285 143.102 104.317 143.17 104.364 143.228C104.411 143.286 104.471 143.332 104.54 143.363C104.609 143.394 104.685 143.41 104.762 143.407C106.139 143.386 106.811 143.311 108.542 143.311C109.606 143.311 112.361 143.416 113.83 143.416C115.3 143.416 115.574 142.02 114.977 141.894C112.304 141.33 110.77 140.548 109.946 139.804C109.794 139.669 109.595 139.595 109.388 139.595Z"
        fill="var(--black)"
      />
      <path
        d="M118.639 72.6399L117.506 73.3463C117.419 73.4006 117.467 73.5344 117.602 73.6096L129.81 80.4516C129.914 80.5101 130.032 80.5101 130.076 80.4516L130.791 79.5112C130.839 79.4443 130.791 79.3356 130.669 79.2729L118.897 72.665C118.861 72.6382 118.817 72.6216 118.772 72.6172C118.726 72.6127 118.681 72.6206 118.639 72.6399Z"
        fill="var(--black)"
      />
      <path
        d="M125.554 60.3816C124.73 61.0127 123.946 61.5226 123.113 62.0534C122.28 62.5842 121.434 63.0398 120.562 63.4912C118.812 64.4092 116.97 65.1555 115.064 65.7189C114.829 65.7983 114.576 65.8527 114.336 65.9153C114.096 65.978 113.865 66.0407 113.578 66.0992C112.953 66.2337 112.308 66.2648 111.672 66.1912C110.998 66.1143 110.349 65.8975 109.771 65.5559C109.234 65.2303 108.763 64.8139 108.38 64.3271C107.735 63.4647 107.273 62.4891 107.02 61.4557C106.891 60.9793 106.798 60.4946 106.741 60.0054C106.672 59.5179 106.638 59.0262 106.641 58.5342L108.315 58.3963C108.517 59.2122 108.79 60.0105 109.13 60.7828C109.427 61.4903 109.857 62.1393 110.399 62.6971C110.594 62.9073 110.831 63.0773 111.096 63.1966C111.362 63.3159 111.65 63.382 111.943 63.3909C112.25 63.3886 112.556 63.3421 112.849 63.253C113.229 63.1359 113.673 63.0022 114.079 62.8601C115.757 62.2552 117.38 61.5185 118.932 60.6574C119.725 60.2395 120.484 59.7588 121.251 59.2949C122.018 58.831 122.773 58.3085 123.431 57.832L125.554 60.3816Z"
        fill="#FFC3BD"
      />
      <path
        d="M120.161 59.2835L121.67 63.6553L123.087 62.8403L121.761 58.5061L120.161 59.2835Z"
        fill="white"
      />
      <path
        d="M111.132 140.219C110.769 140.212 110.408 140.169 110.055 140.089C110.039 140.085 110.024 140.077 110.014 140.065C110.003 140.053 109.996 140.038 109.994 140.022C109.994 140.007 109.998 139.991 110.006 139.978C110.015 139.965 110.027 139.954 110.042 139.947C110.303 139.826 111.646 139.245 112.004 139.475C112.038 139.498 112.065 139.53 112.082 139.566C112.099 139.603 112.105 139.644 112.1 139.684C112.098 139.754 112.079 139.823 112.045 139.885C112.011 139.948 111.963 140.002 111.903 140.043C111.671 140.177 111.402 140.238 111.132 140.219ZM110.329 139.989C110.765 140.064 111.498 140.148 111.807 139.922C111.849 139.894 111.884 139.856 111.907 139.812C111.931 139.769 111.943 139.72 111.943 139.671C111.945 139.658 111.944 139.645 111.939 139.632C111.935 139.62 111.927 139.609 111.916 139.6C111.72 139.475 110.914 139.742 110.329 139.989Z"
        fill="var(--brandPrimary)"
      />
      <path
        d="M110.072 140.089C110.057 140.095 110.04 140.095 110.024 140.089C110.012 140.081 110.003 140.069 109.998 140.055C109.993 140.042 109.993 140.027 109.998 140.014C109.998 139.955 110.338 138.588 111.123 138.685C111.328 138.705 111.38 138.806 111.393 138.881C111.446 139.24 110.547 139.926 110.085 140.101L110.072 140.089ZM111.053 138.814C110.582 138.814 110.299 139.546 110.181 139.876C110.617 139.637 111.254 139.094 111.223 138.885C111.223 138.852 111.175 138.827 111.092 138.818L111.053 138.814Z"
        fill="var(--brandPrimary)"
      />
      <path
        d="M119.451 74.7927L119.137 74.6171C119.076 74.5795 119.045 74.521 119.071 74.4876L120.013 73.2713C120.039 73.2379 120.113 73.2379 120.174 73.2713L120.493 73.451C120.554 73.4845 120.584 73.543 120.558 73.5764L119.616 74.7927C119.59 74.8261 119.516 74.8261 119.451 74.7927Z"
        fill="var(--brandPrimary)"
      />
      <path
        d="M128.847 80.0642L128.533 79.8845C128.472 79.8511 128.441 79.7926 128.467 79.7591L129.409 78.5429C129.435 78.5094 129.509 78.5094 129.57 78.5429L129.889 78.7184C129.95 78.756 129.98 78.8145 129.95 78.848L129.012 80.0642C128.986 80.0977 128.912 80.0977 128.847 80.0642Z"
        fill="var(--brandPrimary)"
      />
      <path
        d="M124.151 77.4256L123.832 77.2501C123.771 77.2167 123.741 77.1582 123.771 77.1205L124.709 75.9085C124.739 75.8708 124.809 75.8708 124.874 75.9085L125.188 76.084C125.254 76.1174 125.28 76.176 125.254 76.2136L124.312 77.4256C124.286 77.4633 124.212 77.4633 124.151 77.4256Z"
        fill="var(--brandPrimary)"
      />
      <path
        opacity="0.4"
        d="M119.451 74.7927L119.137 74.6171C119.076 74.5795 119.045 74.521 119.071 74.4876L120.013 73.2713C120.039 73.2379 120.113 73.2379 120.174 73.2713L120.493 73.451C120.554 73.4845 120.584 73.543 120.558 73.5764L119.616 74.7927C119.59 74.8261 119.516 74.8261 119.451 74.7927Z"
        fill="var(--black)"
      />
      <path
        opacity="0.4"
        d="M128.847 80.0642L128.533 79.8845C128.472 79.8511 128.441 79.7926 128.467 79.7591L129.409 78.5429C129.435 78.5094 129.509 78.5094 129.57 78.5429L129.889 78.7184C129.95 78.756 129.98 78.8145 129.95 78.848L129.012 80.0642C128.986 80.0977 128.912 80.0977 128.847 80.0642Z"
        fill="var(--black)"
      />
      <path
        opacity="0.4"
        d="M124.151 77.4256L123.832 77.2501C123.771 77.2167 123.741 77.1582 123.771 77.1205L124.709 75.9085C124.739 75.8708 124.809 75.8708 124.874 75.9085L125.188 76.084C125.254 76.1174 125.28 76.176 125.254 76.2136L124.312 77.4256C124.286 77.4633 124.212 77.4633 124.151 77.4256Z"
        fill="var(--black)"
      />
      <path
        d="M132.875 58.5687C132.875 56.0609 132.003 46.1929 136.293 45.357C137.649 43.9861 144.368 43.844 145.397 47.3298C146.757 51.9064 144.743 63.0743 144.743 63.0743L132.875 58.5687Z"
        fill="var(--black)"
      />
      <path
        d="M145.637 63.0992C145.622 63.0977 145.608 63.0934 145.596 63.0866C145.583 63.0799 145.572 63.0708 145.563 63.0599C145.554 63.049 145.548 63.0366 145.544 63.0232C145.54 63.0099 145.539 62.9959 145.541 62.9822C145.541 62.8693 146.958 51.6973 145.393 47.2753C144.957 46.0632 143.744 45.2148 141.948 44.8804C139.611 44.4416 137.082 44.9891 136.38 45.7665C136.36 45.7856 136.333 45.7963 136.304 45.7963C136.276 45.7963 136.248 45.7856 136.228 45.7665C136.208 45.7462 136.196 45.7193 136.196 45.6912C136.196 45.6632 136.208 45.6362 136.228 45.616C137.048 44.7049 139.799 44.2493 142.005 44.6631C143.88 45.01 145.161 45.9169 145.615 47.1959C147.193 51.6722 145.785 62.8819 145.772 62.9947C145.772 63.0106 145.768 63.0262 145.76 63.0404C145.753 63.0547 145.743 63.0672 145.73 63.0772C145.717 63.0871 145.702 63.0943 145.686 63.0981C145.67 63.1019 145.653 63.1023 145.637 63.0992Z"
        fill="var(--black)"
      />
      <path
        d="M135.848 52.3272C135.19 54.1411 133.699 57.3134 131.846 57.7314C131.846 57.7314 131.301 59.6456 134.462 61.4178C137.95 63.3655 137.13 60.6947 137.13 60.6947C135.5 59.1984 136.367 57.8777 137.47 56.7993L135.848 52.3272Z"
        fill="#FFC3BD"
      />
      <path
        d="M136.502 54.1503L137.461 56.7959C137.202 57.0458 136.964 57.3156 136.751 57.6026C136.088 57.0969 135.377 55.8639 135.743 55.0949C135.935 54.739 136.192 54.419 136.502 54.1503Z"
        fill="#ED847E"
      />
      <path
        d="M135.874 48.7117C134.972 51.7502 134.523 53.0167 135.53 55.0688C137.043 58.1617 141.128 58.5588 142.942 55.842C144.59 53.397 145.785 48.8412 143.186 46.647C142.616 46.1611 141.927 45.8223 141.182 45.6626C140.438 45.5029 139.664 45.5275 138.932 45.734C138.201 45.9406 137.536 46.3224 137.001 46.8433C136.466 47.3643 136.078 48.0073 135.874 48.7117Z"
        fill="#FFC3BD"
      />
      <path
        d="M134.946 50.6263C137.2 51.4329 142.497 48.7538 143.941 47.1112C144.132 44.5784 137.937 45.5773 137.937 45.5773C137.937 45.5773 134.632 44.6035 134.946 50.6263Z"
        fill="var(--black)"
      />
      <path
        d="M134.409 51.232C134.262 51.8257 134.367 52.4511 134.701 52.9707C135.137 53.6561 135.939 53.3886 136.288 52.7115C136.602 52.093 136.746 50.9854 136.07 50.5382C135.92 50.4433 135.747 50.3858 135.568 50.371C135.389 50.3562 135.208 50.3846 135.043 50.4535C134.878 50.5224 134.734 50.6297 134.623 50.7656C134.512 50.9016 134.439 51.0618 134.409 51.232Z"
        fill="#FFC3BD"
      />
      <path
        d="M140.274 51.1321C140.182 51.3745 140.243 51.617 140.409 51.6713C140.574 51.7256 140.779 51.5752 140.871 51.3328C140.962 51.0903 140.897 50.8521 140.731 50.7936C140.566 50.7351 140.361 50.8897 140.274 51.1321Z"
        fill="var(--black)"
      />
      <path
        d="M143.125 52.0973C143.038 52.3397 143.099 52.5779 143.265 52.6364C143.43 52.6949 143.635 52.5403 143.722 52.2979C143.81 52.0555 143.749 51.813 143.587 51.7587C143.426 51.7044 143.217 51.8548 143.125 52.0973Z"
        fill="var(--black)"
      />
      <path
        d="M143.509 51.7444L144.176 51.782C144.176 51.782 143.696 52.1331 143.509 51.7444Z"
        fill="var(--black)"
      />
      <path
        d="M142.218 52.2579C142.241 52.8852 142.353 53.5066 142.55 54.1053C142.389 54.1506 142.219 54.1613 142.053 54.1367C141.888 54.1122 141.73 54.0529 141.59 53.9632L142.218 52.2579Z"
        fill="#ED847E"
      />
      <path
        d="M140.378 54.6222H140.352C140.01 54.5156 139.699 54.3322 139.446 54.0872C139.193 53.8422 139.004 53.5427 138.896 53.2137C138.892 53.1938 138.896 53.1732 138.907 53.1561C138.919 53.139 138.937 53.1267 138.957 53.1217C138.967 53.1193 138.978 53.1189 138.988 53.1206C138.998 53.1222 139.008 53.126 139.016 53.1315C139.025 53.137 139.032 53.1442 139.038 53.1526C139.043 53.161 139.047 53.1704 139.049 53.1802C139.154 53.4827 139.332 53.7576 139.567 53.9831C139.802 54.2087 140.089 54.3788 140.405 54.4801C140.422 54.4859 140.437 54.4976 140.446 54.5129C140.456 54.5282 140.459 54.5463 140.456 54.5638C140.453 54.5814 140.443 54.5973 140.429 54.6088C140.415 54.6202 140.397 54.6265 140.378 54.6264V54.6222Z"
        fill="var(--black)"
      />
      <path
        d="M140.147 50.1732C140.112 50.1737 140.077 50.1627 140.049 50.142C140.021 50.1213 140.001 50.0921 139.992 50.0592C139.984 50.0263 139.987 49.9916 140.002 49.9607C140.016 49.9298 140.041 49.9045 140.073 49.889C140.29 49.7716 140.532 49.7054 140.781 49.6959C141.03 49.6865 141.277 49.734 141.503 49.8346C141.523 49.8426 141.542 49.8546 141.557 49.8699C141.572 49.8851 141.584 49.9033 141.591 49.9232C141.599 49.9431 141.602 49.9642 141.6 49.9853C141.598 50.0063 141.592 50.0268 141.582 50.0454C141.571 50.064 141.557 50.0802 141.539 50.0931C141.522 50.106 141.502 50.1152 141.48 50.1202C141.459 50.1251 141.437 50.1257 141.415 50.1219C141.393 50.1181 141.373 50.1099 141.355 50.098C141.174 50.0213 140.978 49.9867 140.781 49.9969C140.584 50.0071 140.392 50.0617 140.221 50.1565C140.198 50.168 140.173 50.1737 140.147 50.1732Z"
        fill="var(--black)"
      />
      <path
        d="M144.935 51.2823C144.9 51.2822 144.867 51.2711 144.84 51.2506C144.813 51.2301 144.794 51.2015 144.787 51.1695C144.743 50.9855 144.654 50.814 144.529 50.6688C144.403 50.5236 144.243 50.4087 144.063 50.3335C144.023 50.3202 143.991 50.2927 143.972 50.2568C143.953 50.221 143.95 50.1795 143.963 50.1413C143.969 50.1223 143.979 50.1047 143.993 50.0896C144.007 50.0746 144.023 50.0624 144.042 50.0538C144.061 50.0451 144.081 50.0403 144.102 50.0395C144.123 50.0388 144.144 50.0421 144.163 50.0493C144.394 50.1402 144.598 50.2829 144.759 50.4655C144.92 50.6481 145.033 50.8652 145.087 51.0984C145.093 51.1176 145.094 51.1376 145.091 51.1573C145.088 51.177 145.081 51.1959 145.071 51.213C145.06 51.2301 145.046 51.245 145.03 51.2569C145.013 51.2688 144.994 51.2774 144.974 51.2823H144.935Z"
        fill="var(--black)"
      />
      <path
        d="M140.644 50.7829L141.311 50.8205C141.311 50.8205 140.845 51.1674 140.644 50.7829Z"
        fill="var(--black)"
      />
      <path
        d="M126.518 55.5868C125.145 55.2734 120.92 58.3579 120.92 58.3579L122.712 63.8373C122.712 63.8373 127.129 61.4926 127.538 59.7664C127.944 57.9775 128.083 55.9463 126.518 55.5868Z"
        fill="var(--brandPrimary)"
      />
      <path
        opacity="0.7"
        d="M126.518 55.5868C125.145 55.2734 120.92 58.3579 120.92 58.3579L122.712 63.8373C122.712 63.8373 127.129 61.4926 127.538 59.7664C127.944 57.9775 128.083 55.9463 126.518 55.5868Z"
        fill="white"
      />
    </g>
  </svg>
</template>
